import { ValueOf } from '@/types/util';

export const EWalletUserSignupMethod = {
  PHONE: 'SMS認証',
  EMAIL: 'メールアドレス認証',
  TEMP_PASSWORD: '仮パスワード認証',
  JWT: 'JWT認証',
} as const;

export type WalletUserSignupMethodKey = keyof typeof EWalletUserSignupMethod;
export type WalletUserSignupMethodValue = ValueOf<typeof EWalletUserSignupMethod>;

export const walletUserSignupMethodKeys = Object.keys(EWalletUserSignupMethod) as WalletUserSignupMethodKey[];

/** v-select用items */
export const walletUserSignupMethodItems = walletUserSignupMethodKeys
  .map((key) => ({
    title: EWalletUserSignupMethod[key],
    value: key,
  }));
